module.exports = {
      id: "saudi-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#saudi",
      toString: function () {
        return this.url;
      }
    }